import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'
import './model'

// skin
const skin = era.skin('widgets/Popups/InfoPopup/')

InfoPopup.displayName = 'InfoPopup'
export function InfoPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='infoPopup' />
}
